/* Hadley Bricks: cart add-on rail. Adds via AJAX and lets Horizon's cart-items-component
   morph the drawer through the standard CartLinesUpdateEvent (same flow as product-form.js).
   Without JS the form posts to /cart/add as normal. */
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-hb-addon]')) return;
  event.preventDefault();
  const button = form.querySelector('button');
  if (button) button.disabled = true;

  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const json = await res.json();
    const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'hb-addon', sections: json.sections, didError: Boolean(json.status) },
    });
  } catch (error) {
    deferred.reject(error);
    form.submit();
  } finally {
    if (button) button.disabled = false;
  }
});
